import React, { useState } from "react";
import axios from "axios";
import { api } from "./convex/_generated/api";
import { useQuery } from "convex/react";
import { useNavigate, useLocation } from "react-router-dom";
import "./ProgressForm.css";

export default function ProgressForm() {
  const categories = [
    {
      name: "PhysicalHealth",
      habits: [
        ["exercise", "Exercise"],
        ["walking", "Walking"],
        ["running", "Running"],
        ["stretching", "Stretching"],
        ["drinking-water", "Drinking Water"],
        ["eating-healthy", "Eating Healthy"],
        ["taking-vitamins", "Taking Vitamins"],
        ["sleep-schedule", "Maintaining a Sleep Schedule"],
        ["getting-sunlight", "Getting Sunlight"],
      ],
    },
    {
      name: "MentalEmotional",
      habits: [
        ["meditation", "Meditation"],
        ["journaling", "Journaling"],
        ["gratitude", "Gratitude"],
        ["deep-breathing", "Deep Breathing"],
        ["reading", "Reading"],
        ["digital-detox", "Digital Detox"],
        ["mindfulness", "Practicing Mindfulness"],
        ["positive-self-talk", "Positive Self-Talk"],
      ],
    },
    {
      name: "LearningGrowth",
      habits: [
        ["reading-book", "Reading a Book"],
        ["studying", "Studying"],
        ["learning-language", "Learning a Language"],
        ["coding", "Coding"],
        ["practicing-instrument", "Practicing an Instrument"],
        ["online-course", "Taking an Online Course"],
        ["writing", "Writing"],
        ["learning-skill", "Learning a New Skill"],
      ],
    },
    {
      name: "ProductivityCareer",
      habits: [
        ["planning-day", "Planning the Day"],
        ["setting-daily-goals", "Setting Daily Goals"],
        ["checking-email", "Checking Email"],
        ["working-project", "Working on a Project"],
        ["networking", "Networking"],
        ["applying-jobs", "Applying for Jobs"],
        ["building-portfolio", "Building a Portfolio"],
        ["reviewing-progress", "Reviewing Progress"],
      ],
    },
    {
      name: "Financial",
      habits: [
        ["tracking-expenses", "Tracking Expenses"],
        ["saving-money", "Saving Money"],
        ["budgeting", "Budgeting"],
        ["investing", "Investing"],
        ["avoiding-unnecessary-purchases", "Avoiding Unnecessary Purchases"],
        ["paying-bills", "Paying Bills on Time"],
      ],
    },
    {
      name: "PersonalLifestyle",
      habits: [
        ["cleaning", "Cleaning"],
        ["making-bed", "Making the Bed"],
        ["organizing-room", "Organizing Your Room"],
        ["doing-laundry", "Doing Laundry"],
        ["meal-prepping", "Meal Prepping"],
        ["personal-hygiene", "Personal Hygiene"],
        ["skincare", "Skincare"],
        ["limiting-screen-time", "Limiting Screen Time"],
      ],
    },
    {
      name: "SocialRelationships",
      habits: [
        ["calling-family", "Calling Family"],
        ["checking-in-with-friend", "Checking in With a Friend"],
        ["quality-time", "Spending Quality Time With Someone"],
        ["meeting-new-people", "Meeting New People"],
        ["active-listening", "Practicing Active Listening"],
        ["expressing-appreciation", "Expressing Appreciation"],
      ],
    },
  ];

  

  const [physicalHealth, setPhysicalHealth] = useState("");
  const [mentalEmotionalHabit, setMentalEmotionalHabit] = useState("");
  const [learningGrowth, setLearningGrowth] = useState("");
  const [productivityCareer, setProductivityCareer] = useState("");
  const [financial, setFinancial] = useState("");
  const [personalLifestyle, setPersonalLifestyle] = useState("");
  const [socialRelationships, setSocialRelationships] = useState("");

  const [mood, setMood] = useState("");
  const [time, setTime] = useState("");
  const [sleep, setSleep] = useState("");
  const [mentalhealth, setMentalHealth] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const sessionId = location.state?.sessionId;

  const user = useQuery(
    api.users.getUserBySession,
    sessionId ? { sessionId } : "skip"
  );

  const userId= user?._id;

   const premiumUser = useQuery(
    api.users.getPremiumUserById,
    userId
      ? { userId }
      : "skip"
  );
  
  if (premiumUser === null) {
    navigate("/auth");
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
         `${process.env.REACT_APP_API_URL}/progressSuggestions`,
        {
          userId: user._id,
          physicalHealth,
          mentalEmotionalHabit,
          learningGrowth,
          productivityCareer,
          financial,
          personalLifestyle,
          socialRelationships,
          mood,
          time,
          sleep,
          mentalhealth,
        }
      );

      navigate("/suggestions", {
        state: {
          userId: user._id,
          suggestions: "response.data.suggestions",
          sessionId: sessionId,
        },
      });
    } catch (error) {
      console.error("Error:", error);

      setError(
        error.response?.data?.message ||
          "Failed to submit progress information."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="progress-page">
      <div className="progress-container">

        <div className="progress-header">
          <div className="check-in-badge">DAILY CHECK-IN</div>

          <h1>Progress Check-In</h1>

          <p>
            Select a habit from each category.
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="progress-form"
        >

          {/* Physical Health */}
          <div className="form-section">
            <label>Physical Health</label>

            <select
              value={physicalHealth}
              onChange={(e) => setPhysicalHealth(e.target.value)}
            >
              <option value="">
                Select a physical health habit
              </option>

              {categories[0].habits.map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          {/* Mental & Emotional */}
          <div className="form-section">
            <label>Mental & Emotional</label>

            <select
              value={mentalEmotionalHabit}
              onChange={(e) =>
                setMentalEmotionalHabit(e.target.value)
              }
            >
              <option value="">
                Select a mental & emotional habit
              </option>

              {categories[1].habits.map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          {/* Learning & Growth */}
          <div className="form-section">
            <label>Learning & Growth</label>

            <select
              value={learningGrowth}
              onChange={(e) => setLearningGrowth(e.target.value)}
            >
              <option value="">
                Select a learning habit
              </option>

              {categories[2].habits.map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          {/* Productivity & Career */}
          <div className="form-section">
            <label>Productivity & Career</label>

            <select
              value={productivityCareer}
              onChange={(e) =>
                setProductivityCareer(e.target.value)
              }
            >
              <option value="">
                Select a productivity habit
              </option>

              {categories[3].habits.map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          {/* Financial */}
          <div className="form-section">
            <label>Financial</label>

            <select
              value={financial}
              onChange={(e) => setFinancial(e.target.value)}
            >
              <option value="">
                Select a financial habit
              </option>

              {categories[4].habits.map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          {/* Personal & Lifestyle */}
          <div className="form-section">
            <label>Personal & Lifestyle</label>

            <select
              value={personalLifestyle}
              onChange={(e) =>
                setPersonalLifestyle(e.target.value)
              }
            >
              <option value="">
                Select a lifestyle habit
              </option>

              {categories[5].habits.map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          {/* Social & Relationships */}
          <div className="form-section">
            <label>Social & Relationships</label>

            <select
              value={socialRelationships}
              onChange={(e) =>
                setSocialRelationships(e.target.value)
              }
            >
              <option value="">
                Select a social habit
              </option>

              {categories[6].habits.map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          {/* Mood */}
          <div className="form-section">
            <label>How is your mood?</label>

            <select
              value={mood}
              onChange={(e) => setMood(e.target.value)}
            >
              <option value="">Select your mood</option>
              <option value="great">Great</option>
              <option value="good">Good</option>
              <option value="okay">Okay</option>
              <option value="low">Low</option>
              <option value="very-low">Very Low</option>
            </select>
          </div>

          {/* Time */}
          <div className="form-section">
            <label>Time Available Today</label>

            <select
              value={time}
              onChange={(e) => setTime(e.target.value)}
            >
              <option value="">Select available time</option>
              <option value="15-minutes">15 minutes</option>
              <option value="30-minutes">30 minutes</option>
              <option value="1-hour">1 hour</option>
              <option value="2-hours">2 hours</option>
              <option value="3-plus-hours">3+ hours</option>
            </select>
          </div>

          {/* Sleep */}
          <div className="form-section">
            <label>Sleep</label>

            <select
              value={sleep}
              onChange={(e) => setSleep(e.target.value)}
            >
              <option value="">
                How much did you sleep?
              </option>
              <option value="less-than-5">
                Less than 5 hours
              </option>
              <option value="5-6">5–6 hours</option>
              <option value="6-7">6–7 hours</option>
              <option value="7-8">7–8 hours</option>
              <option value="8-plus">8+ hours</option>
            </select>
          </div>

          {/* Mental Wellbeing */}
          <div className="form-section">
            <label>Mental Wellbeing</label>

            <select
              value={mentalhealth}
              onChange={(e) => setMentalHealth(e.target.value)}
            >
              <option value="">
                How are you feeling mentally?
              </option>
              <option value="excellent">Excellent</option>
              <option value="good">Good</option>
              <option value="okay">Okay</option>
              <option value="stressed">Stressed</option>
              <option value="overwhelmed">Overwhelmed</option>
            </select>
          </div>

          {/* Error */}
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          {/* Submit */}
          <button
            type="submit"
            className="submit-button"
          >
            Get My Progress Suggestions →
          </button>

        </form>
      </div>
    </div>
  );
}
